import { axios } from '../../lib'
import toast from 'react-hot-toast'
import TYPES from '../types'

const altOrderLists = (data) => ({
  type: TYPES.ALT_ORDER_LISTS,
  data,
})

export const getAllOrders = (page = 1, limit = 10, status = '', search = '') => async (dispatch) => {
  try {
    const params = new URLSearchParams({ page, limit, search })
    if (status) params.append('status', status)
    
    const response = await axios.get(`/order?${params.toString()}`)
    
    if (response && response.data) {
      const normalizedData = {
        data: response.data || [],
        pagination: response.pagination || {},
      }
      
      dispatch(altOrderLists(normalizedData))
      return normalizedData
    }
  } catch (error) {
    console.error('Get orders error:', error)
    toast.error(error.response?.data?.message || 'Failed to fetch orders')
  }
}

export const getOrderStats = () => async (dispatch) => {
  try {
    const response = await axios.get('/order/stats')
    return response.data
  } catch (error) {
    console.error('Get order stats error:', error)
    return null
  }
}

export const getOrderById = (id) => async (dispatch) => {
  try {
    const response = await axios.get(`/order/${id}`)
    return response.data
  } catch (error) {
    console.error('Get order error:', error)
    toast.error(error.response?.data?.message || 'Failed to fetch order')
    return null
  }
}

export const trackOrder = (trackingNumber) => async (dispatch) => {
  try {
    const response = await axios.get(`/order/track/${trackingNumber}`)
    return response.data
  } catch (error) {
    console.error('Track order error:', error)
    toast.error(error.response?.data?.message || 'Order not found')
    return null
  }
}

export const createOrder = (orderData) => async (dispatch) => {
  try {
    const response = await axios.post('/order', orderData)
    
    if (response && response.status === 'success') {
      toast.success('Order created successfully')
      dispatch(getAllOrders())
      return { success: true, data: response.data }
    }
  } catch (error) {
    console.error('Create order error:', error)
    const message = error.response?.data?.message || 'Failed to create order'
    toast.error(message)
    return { success: false, error: message }
  }
}

export const updateOrder = (id, orderData) => async (dispatch) => {
  try {
    const response = await axios.put(`/order/${id}`, orderData)
    
    if (response && response.status === 'success') {
      toast.success('Order updated successfully')
      dispatch(getAllOrders())
      return { success: true }
    }
  } catch (error) {
    console.error('Update order error:', error)
    const message = error.response?.data?.message || 'Failed to update order'
    toast.error(message)
    return { success: false, error: message }
  }
}

export const assignRider = (orderId, riderId) => async (dispatch) => {
  try {
    const response = await axios.patch(`/order/${orderId}/assign`, { riderId })
    
    if (response && response.status === 'success') {
      toast.success('Rider assigned successfully')
      dispatch(getAllOrders())
      return { success: true }
    }
  } catch (error) {
    console.error('Assign rider error:', error)
    toast.error(error.response?.data?.message || 'Failed to assign rider')
    return { success: false }
  }
}

export const updateOrderStatus = (orderId, status) => async (dispatch) => {
  try {
    const response = await axios.patch(`/order/${orderId}/status`, { status })
    
    if (response && response.status === 'success') {
      toast.success('Order status updated successfully')
      dispatch(getAllOrders())
      return { success: true }
    }
  } catch (error) {
    console.error('Update order status error:', error)
    toast.error(error.response?.data?.message || 'Failed to update order status')
    return { success: false }
  }
}

export const cancelOrder = (orderId) => async (dispatch) => {
  try {
    const response = await axios.patch(`/order/${orderId}/cancel`)
    
    if (response && response.status === 'success') {
      toast.success('Order cancelled successfully')
      dispatch(getAllOrders())
      return { success: true }
    }
  } catch (error) {
    console.error('Cancel order error:', error)
    toast.error(error.response?.data?.message || 'Failed to cancel order')
    return { success: false }
  }
}

export const deleteOrder = (orderId) => async (dispatch) => {
  try {
    const response = await axios.delete(`/order/${orderId}`)
    
    if (response && response.status === 'success') {
      toast.success('Order deleted successfully')
      dispatch(getAllOrders())
      return { success: true }
    }
  } catch (error) {
    console.error('Delete order error:', error)
    toast.error(error.response?.data?.message || 'Failed to delete order')
    return { success: false }
  }
}
